<template>
  <div id="main-container" class="mt-0">
    <b-container fluid>
      <b-row align-h="between" id="header">
        <b-col cols="4" id="logo-container" class="text-center">
          <img
            src="@/assets/images/brand/logo-auth.svg"
            alt="logo-urbnx"
            id="logo"
          />
          <p id="subtitle-logo">SPACE AREA</p>
        </b-col>
        <b-col cols="4" class="mt-4" id="signup">
          <a :href="getSignupUrl()">
            <b-button variant="primary" id="signup-button">{{
              $t("login.header.signup-link")
            }}</b-button>
          </a>
        </b-col>
      </b-row>
    </b-container>
    <div id="login-container" class="mt-4 text-initial">
      <div>
        <div id="info">
          <h1>{{ $t("login.title") }}</h1>
          <p>
            {{ $t("login.description") }}
          </p>
        </div>
        <b-form-group>
          <div id="login" class="mt-4">
            <b-form-input
              v-model.trim="$v.email.$model"
              :placeholder="$t('login.form.email-placeholder')"
              class="form"
              type="email"
            />
            <b-form-input
              v-model.trim="$v.password.$model"
              :placeholder="$t('login.form.password-placeholder')"
              class="form"
              type="password"
            />
            <router-link :to="{ name: 'ForgotPasswordPage' }">
              <p class="mt-2">{{ $t("login.form.forgot-password-label") }}</p>
            </router-link>
            <router-link :to="{ name: 'ConfirmEmailPage' }">
              <p class="mt-n2">{{ $t("login.auth-email.title") }}</p>
            </router-link>
          </div>
          <MessageBanner :message="error" :type="'error'" v-if="error !== ''" />
          <div id="login-button" class="mt-4">
            <LoadingButton
              :text="$t('login.form.cta-submit')"
              :classes="['btn-primary', 'w-100']"
              :loading="loading"
              :disabled="$v.$invalid"
              @click="login()"
            />
          </div>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
import { email, required } from "vuelidate/lib/validators";
import AuthService from "@/services/auth";

export default {
  data() {
    return {
      email: "",
      password: "",
      error: "",
      loading: false
    };
  },
  validations: {
    email: {
      email,
      required
    },
    password: {
      required
    }
  },
  methods: {
    getSignupUrl() {
      return `${process.env.VUE_APP_LANDING_URL}/sign-up`;
    },
    async login() {
      this.loading = true;
      this.error = "";

      if (!this.$v.$invalid) {
        try {
          const { data, headers } = await AuthService.login(
            this.email,
            this.password
          );

          this.$store.dispatch("currentUser/login", {
            user: data,
            headers
          });
        } catch (error) {
          this.error = "Invalid credentials";
        } finally {
          this.loading = false;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/pages/auth";
@import "src/assets/scss/buttons";
</style>



// WEBPACK FOOTER //
// src/pages/auth/login/LoginPage.vue